import { RouteRecordRaw } from "vue-router";

export const maintenance: RouteRecordRaw = {
  path: "/maintenance",
  component: () =>
    import(/* webpackChunkName: "maintenance" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "",
      name: "Maintenance",
      component: () =>
        import(
          /* webpackChunkName: "maintenance" */ "@/views/maintenance/index.vue"
        ),
      meta: {
        isBeforeLogin: true,
        isMaintenancePage: true
      }
    }
  ]
};
